import { render, staticRenderFns } from "./kw_seeks_relation.vue?vue&type=template&id=bc77530e&scoped=true&"
import script from "./kw_seeks_relation.vue?vue&type=script&lang=js&"
export * from "./kw_seeks_relation.vue?vue&type=script&lang=js&"
import style0 from "./kw_seeks_relation.vue?vue&type=style&index=0&id=bc77530e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc77530e",
  null
  
)

component.options.__file = "kw_seeks_relation.vue"
export default component.exports